import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class DefaultsService extends ClientDataService {
  private PROCEDURE_DEFAULTS_DOC = 'cmdfac_prprocedure_defaults'

  async getProcedureDefaults(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PROCEDURE_DEFAULTS_DOC)
  }
}
